module.exports = __webpack_public_path__ + "static/media/lumenlife-3.7664462a.jpg";